import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import { Table } from "../Table";
import { DeleteModal, Modal } from "../Modal";
import {
  deleteDiagnosisOption,
  fetchDiagnosisOptions,
} from "../../utils/queries/diagnosisOptions";
import handleSearch from "../../utils/handleSearch";
import { getStorage } from "../../utils/storage";
import NewDiagnosisOption from "./NewDiagnosisOption";
import icons from "../../constants/icons";

let copyData = [];

class DiagnosisOptions extends React.Component {
  state = {
    isLoading: false,
    isDeleting: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    delete_value: "",
    error: {},
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });
    this.getData(true);
  };

  getData = async (isLoading) => {
    try {
      const { defaultLanguage } = this.props;
      const { page, limit } = this.state;

      this.setState({ isLoading });
      const { data, count, totalRecords } = await fetchDiagnosisOptions(defaultLanguage, {
        page,
        limit,
      });

      this.setState({
        data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handlePagination = (page) => {
    this.setState({ page }, () => this.getData(true));
  };

  handleShowModal = (modal, modalTitle, selectedData = {}) => {
    this.setState({
      [modal]: true,
      modalTitle,
      selectedData,
    });
  };

  handleCloseModal = (modal) => {
    this.setState({
      [modal]: false,
      selectedData: {},
      delete_value: "",
      error: {},
    });
  };

  onChangeText = (field, e) => {
    const { error } = this.state;
    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  };

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });
      await deleteDiagnosisOption(
        this.props.defaultLanguage,
        this.state.selectedData._id
      );
      this.setState({ isDeleting: false });
      this.handleCloseModal("showDeleteModal");
      this.getData(true);
    } catch (error) {
      this.setState({ isDeleting: false });
    }
  };

  returnTableHeaders() {
    return [
      {
        title: language[this.props.defaultLanguage].label,
        key: "label",
      },
      {
        title: language[this.props.defaultLanguage].value,
        key: "value",
      },
      {
        title: language[this.props.defaultLanguage].product_type,
        key: "productTypes",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "action",
      },
    ];
  }

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          handleSearch={(e) =>
            handleSearch(this, {
              copyData,
              value: e?.target?.value,
            })
          }
          showAdd
          addButtonText={language[this.props.defaultLanguage].add}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            language[this.props.defaultLanguage].add
          )}
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination}
          headers={this.returnTableHeaders()}
          actions={[
            {
              canAccess: true,
              name: language[this.props.defaultLanguage].edit,
              onPress: (item) =>
                this.handleShowModal(
                  "showModal",
                  language[this.props.defaultLanguage].edit,
                  item
                ),
              icon: icons.edit,
            },
            {
              canAccess: true,
              name: language[this.props.defaultLanguage].delete_,
              onPress: (item) =>
                this.handleShowModal(
                  "showDeleteModal",
                  language[this.props.defaultLanguage].delete_,
                  item
                ),
              icon: icons.delete,
            },
          ]}
        />

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          <NewDiagnosisOption
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData}
            {...this.state.selectedData}
          />
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData.label}
            getData={this.getData}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return { defaultLanguage };
};

export default connect(mapStateToProps)(DiagnosisOptions);
